import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { SectionDivider } from '../components/SectionDivider';
import { ProductSection } from '../components/ProductSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-597">
      <HeroSection data-id="element-598" />
      <StorySection data-id="element-599" />
      <PainSection data-id="element-600" />
      <MechanismSection data-id="element-601" />
      <SectionDivider data-id="element-602" />
      <AboutSection data-id="element-603" />
      <ProductSection data-id="element-604" />
      <TestimonialsSection data-id="element-605" />
      <OfferSection data-id="element-606" />
      <GuaranteeSection data-id="element-607" />
      <UrgencySection data-id="element-608" />
      <ObjectionsSection data-id="element-609" />
      <IdentitySection data-id="element-610" />
      <FinalCTASection data-id="element-611" />
      <Footer data-id="element-612" />
      <RecentPurchaseToast data-id="element-613" />
    </div>;
}